// Suggestions.js - Dynamic suggestion component

import React from 'react';

// Topic-based suggestion categories
const suggestionsByCategory = {
  comics: [
    "What's the reading order for the Marvel Civil War comic event?",
    "Explain the different versions of the Joker throughout DC comics history.",
    "Who are considered the strongest cosmic entities in Marvel comics?",
    "What's the difference between the Ultimate universe and the main 616 Marvel universe?",
    "Explain the Green Lantern Corps and the different lantern colors.",
    "What are the most important Batman graphic novels to read?",
    "How many different Spider-Man variants exist in Marvel comics?",
    "Explain the Crisis on Infinite Earths and how it changed the DC universe."
  ],
  manga_anime: [
    "What are the best manga series for a complete beginner?",
    "Explain the power system in Hunter x Hunter (Nen).",
    "Who are the strongest characters in the One Piece universe?",
    "What are the different Titan types in Attack on Titan?",
    "Explain the Sharingan and its evolution in Naruto.",
    "What are the best Studio Ghibli films to watch first?",
    "How does chakra work in the Naruto universe?",
    "What are the different classes of heroes in One Punch Man?"
  ],
  crossovers: [
    "Who would win in a fight between Superman and Goku?",
    "Compare the infinity stones from Marvel to the dragon balls from Dragon Ball.",
    "How do western comics differ from manga in storytelling techniques?",
    "Who are the fastest speedsters across Marvel and DC?",
    "Compare the Justice League to the Avengers: strengths and weaknesses.",
    "Who are the most powerful psychics across comics, anime, and manga?",
    "Compare the superhero schools in My Hero Academia vs. Marvel's Xavier Institute."
  ]
};

// Function to get random suggestions from categories
const getRandomSuggestions = (count = 6) => {
  const allCategories = Object.keys(suggestionsByCategory);
  const result = [];
  
  // Ensure we get at least one from each category if possible
  for (const category of allCategories) {
    if (result.length < count) {
      const categoryItems = suggestionsByCategory[category];
      const randomIndex = Math.floor(Math.random() * categoryItems.length);
      result.push(categoryItems[randomIndex]);
      
      // Remove the selected item to avoid duplicates
      suggestionsByCategory[category].splice(randomIndex, 1);
    }
  }
  
  // Fill remaining slots with random selections from any category
  const allRemainingItems = Object.values(suggestionsByCategory).flat();
  while (result.length < count && allRemainingItems.length > 0) {
    const randomIndex = Math.floor(Math.random() * allRemainingItems.length);
    result.push(allRemainingItems[randomIndex]);
    allRemainingItems.splice(randomIndex, 1);
  }
  
  return result;
};

const Suggestions = ({ onSuggestionClick }) => {
  const [suggestions, setSuggestions] = React.useState([]);
  
  // Generate random suggestions on component mount
  React.useEffect(() => {
    setSuggestions(getRandomSuggestions());
  }, []);
  
  // Regenerate suggestions function
  const regenerateSuggestions = () => {
    setSuggestions(getRandomSuggestions());
  };
  
  return (
    <div className="suggestions-container">
      <div className="suggestions-header">
        <h2>Explore Geek Culture</h2>
        <button 
          className="refresh-btn" 
          onClick={regenerateSuggestions} 
          title="Get new suggestions"
        >
          ↻
        </button>
      </div>
      
      <div className="suggestion-grid">
        {suggestions.map((suggestion, index) => (
          <div 
            key={index} 
            className="suggestion" 
            onClick={() => onSuggestionClick(suggestion)}
          >
            {suggestion}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Suggestions; 